<template>
    <FilterExpandCollapse label="Country of origin" v-if="origins.length">
      <FilterShowMore :threshold="10" :topLength="3" >
        <div v-for="item in origins" :key="item.id">
          <hp5-semantic size-selection="xs">
            <div class="selection">
              <input :id="item.id" type="checkbox" :value="item.id" v-model="filterContext.origins" />
              <label :for="`${item.id}`">{{ item.description }}</label>
            </div>
          </hp5-semantic>
        </div>
      </FilterShowMore>
    </FilterExpandCollapse>
</template>

<script setup>
      const { origins, filterContext } = useFCPModel()
</script>
  
<style scoped lang="scss">
  .selection {
    display: flex;
    align-items: center;
  }
  label {
    padding-left: var(--spacing-xs);
  }
</style>